/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import JobListItem from "./JobListItem";
import JobLoadedItem from "./JobLoadedItem";

const JobList = ({ jobs, path }) => {
  const jobItems = jobs.map((job, index) => (
    <JobListItem key={`job-${job.id}`} index={index} job={job} path={path} />
  ));

  const jobLoadedItems = jobs.map((job, index) =>
    job.jobItems.map(loadedItem => (
      <JobLoadedItem
        key={`loadedItem-${loadedItem.id}`}
        index={index}
        job={job}
        loadedItem={loadedItem}
      />
    ))
  );

  return (
    <div>
      <h4>Jobs</h4>
      <Table bordered>
        <thead>
          <tr className="header">
            <td>Sequence</td>
            <td>Customer</td>
            <td>Category</td>
            <td>Status</td>
            <td style={{ width: 50 }} />
          </tr>
        </thead>
        <tbody>{jobItems}</tbody>
      </Table>

      <h4>Items</h4>
      <Table bordered>
        <thead>
          <tr className="header">
            <td>Sequence</td>
            <td>Item</td>
            <td>Quantity</td>
            <td>Delivery Status</td>
          </tr>
        </thead>
        <tbody>{jobLoadedItems}</tbody>
      </Table>
    </div>
  );
};
JobList.propTypes = {
  jobs: PropTypes.array,
  path: PropTypes.string
};
JobList.defaultProps = {
  jobs: [],
  path: ""
};

export default JobList;



// WEBPACK FOOTER //
// ./src/components/jobs/JobList.js